import React, { useEffect, useState } from "react";
import ContactTable from "../components/Inquiries/ContactTable";
import api from "../../utilis/api";

const dummyData = Array.from({ length: 45 }, (_, i) => ({
  name: `User Name ${i + 1}`,
  email: `email${i + 1}@gmail.com`,
  phone: `Phone ${i + 1}`,
  message: `Detail information for page ${i + 1}`,
  send_at: `${i + 1}/May/2024`,
}));

const ITEMS_PER_PAGE = 10;

const Contact = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [contact, setContact] = useState([]);
  const getTeachers = async () => {
    try {
      const response = await api.get("/contact");
      console.log(response);
      setContact(response.data.data);
    } catch (error) {
      console.error("Error fetching teachers:", error);
    }
  };

  useEffect(() => {
    getTeachers();
  }, []);
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;

  return (
    <div className="flex flex-col w-full gap-4">
      {/* Header */}
      <div className="bg-gray-700 p-3 w-full">
        <h1 className="font-bold text-[1.3rem]">Manage Contact Inquiries</h1>
      </div>

      {/* Content */}
      <div className="p-2 w-full bg-gray-700">
        <ContactTable
          data={contact.slice(startIndex, endIndex)}
          currentPage={currentPage}
          totalPages={Math.ceil(contact.length / ITEMS_PER_PAGE)}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default Contact;
